// extracted by mini-css-extract-plugin
module.exports = {"panel":"styles_panel__KTBEB","collapse":"styles_collapse__PwQXo"};